import { AgencyGroupListItem } from '../../../integrated-client/models/';

export type AgencyGroupsList = Array<AgencyGroupListItem>;

export class ResultsData {

  items: AgencyGroupsList
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}